import $ from 'jquery';

// The default filter
export default class Filter {
  constructor($element, options) {
    if ($element.length === 0) return false;

    this.reactToOtherFilters();

    this.$element = $element;
    this.filterType = "Filter";
    this.isActive = true;
    this.standalone = $element.data('wjp-filter-standalone') ? true : false;
    // console.log(this.standalone, $element.data('wjp-filter-standalone'));
    if($element.get(0)) {
      $element.get(0).filter = this;
    }

    this.options = {
      onChange: window.WJP.query.updateQuery
    }

    $.extend(this.options, options);
  }

  reactToOtherFilters() {
    $.messages.on('FILTER/VALUE_CHANGED', (action) => {
        if(action.key === this.getKey() && action.sender !== this) {
          this.setValue(action.value);
        }
    });
  }

  getElement() {
    return this.$element;
  }

  syncFilters() {
    let otherFilters = window.WJP.query.getFilters(this.getKey());
    for(let i = 0; i < otherFilters.length ; i++) {
      if (this !== otherFilters[i]) {
        otherFilters[i].setValue(this.value);
      }
    }
  }

  markAsActive() {
    let otherFilters = window.WJP.query.getFilters(this.getKey());
    for(let i = 0; i < otherFilters.length ; i++) {
      otherFilters[i].isActive = false;
    }
    this.isActive = true;
  }
}



/** WEBPACK FOOTER **
 ** ../assets/js/filters/Filter.js
 **/